import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert.service';
import { AuthService } from '../auth.service';
import { setTimeout } from 'timers';


@Component({
  selector: 'app-text-replies',
  templateUrl: './text-replies.component.html',
  styleUrls: ['./text-replies.component.scss']
})

export class textRepliesComponent implements OnInit {

  public allStandings: Standing[];

  public currentTime = new Date;
  public futureTime = new Date;
  public delay = 0;

  constructor(
    private http: HttpClient,
    private alert: AlertService,
    public auth: AuthService,
    @Inject('BASE_URL') private baseUrl: string) {

    this.allStandings = [];

    this.displayData();
  }

  ngOnInit(): void {
    this.futureTime.setTime(this.futureTime.getTime() + 3600000);
    this.futureTime.setMinutes(0);
    this.futureTime.setSeconds(0);

    this.delay = (this.futureTime.getTime() - this.currentTime.getTime());
    setTimeout(() => this.hourlyRefresh(), this.delay);
  }

  displayData(): void {
    this.http.get<Standing[]>(this.baseUrl + 'api/TextReplies/Get').subscribe(result => {
      this.allStandings = result;
    }, error => {
      this.alert.error(`Error getting standings`, false, 3);
      console.error(error)
    });
  }

  popScreen(standing: Standing): void {
    this.http.post<PopScreenResult>(this.baseUrl + 'api/FiservApi/PopScreen', standing).subscribe(result => {
      if (result.HasErrors === true) {
        result.Errors.forEach(error => {
          var errorToShow: string;
          if (error.Description == 'User is not logged in or inactive') {
            errorToShow = 'Please login to Flex to continue';
          } else {
            errorToShow = error.Description;
          }
          this.alert.error(errorToShow, false, 5);
        });
      } else if (!result || result.HasErrors === null) {
        this.alert.error('Error communicating with fiserv.', false, 5);
      } else {
        result.Errors.forEach(error => {
          this.alert.success(error.Description, false, 5);
        })
        //this.alert.success('Successful!', false, 3);
      }
    }, error => {
      this.alert.error('Error communicating with the server.', false, 5);
      console.error(error);
    });
  }

  updateDatabase(standing: Standing): void {
    this.http.post(this.baseUrl + 'api/TextReplies/InsertDelete', standing).subscribe(() => {
      this.displayData();
    }, error => {
      this.alert.error("Error while updating this worklist", false, 3);
      console.error(error)
    });
  }

  hourlyRefresh(): void {
    this.displayData();
    setTimeout(() => this.hourlyRefresh(), 3600000);
  }

}

class Standing {
  TextRepliesID: number;
  accountNumber: string;
  response: string;
  phoneNumber: string;
  dateTimeReceived: Date;
  workQueue: string;
}

interface PopScreenResult {
  Errors: PopScreenError[];
  HasErrors: boolean;
}

interface PopScreenError {
  Description: string;
  ErrorCode: string;
  IsBusinessError: boolean;
}



// WEBPACK FOOTER //
// ./src/app/text-replies/text-replies.component.ts